import { render, staticRenderFns } from "./Biomas.vue?vue&type=template&id=142ee058&lang=pug"
import script from "./Biomas.vue?vue&type=script&lang=js"
export * from "./Biomas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports